import { render, staticRenderFns } from "./Social_panel.vue?vue&type=template&id=413b0eb8&scoped=true&"
import script from "./Social_panel.vue?vue&type=script&lang=js&"
export * from "./Social_panel.vue?vue&type=script&lang=js&"
import style0 from "./Social_panel.vue?vue&type=style&index=0&id=413b0eb8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b0eb8",
  null
  
)

component.options.__file = "Social_panel.vue"
export default component.exports